var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop inset-0 bg-basic-600-48 transition-3ms",class:[{ 'backdrop--visible': _vm.visible }, _vm.position],on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }